export enum BillingPeriod 
{
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
  Annual = 3
}
export enum PlanLevel {
  Free = 0,
  Basic = 1,
  Premium = 2 
} 

export interface PlanPricePointModel {
  period: BillingPeriod;
  amount: number;
}

export interface PlanModel {
  id: number;
  name: string;
  displayName: string;
  level: PlanLevel;
  isTrial: boolean;
  trialPeriodDays: number;
  songsPerDay: number | null;
  pricePoints: PlanPricePointModel[];
  isDefault: boolean;
}

export enum SubscriptionStatus {
  Pending = -1,
  Active = 0,
  Paused = 1,
  Cancelled = 2,
  Expired = 3
}
